import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import BoxOpen80 from './svgs/BoxOpen80';
import Devices80 from './svgs/Devices80';
import MapPin80 from './svgs/MapPin80';
import Printer80 from './svgs/Printer80';

const renderItemDetails = items => (
  items.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key, react/no-danger
    <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
  ))
);

const renderIcon = (icon) => {
  if (icon === 'devices-80') return <Devices80 />;
  if (icon === 'map-pin-80') return <MapPin80 />;
  if (icon === 'printer-80') return <Printer80 />;

  return <BoxOpen80 />;
};

class HowToReturnItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  renderAction(item) {
    const { expanded } = this.state;
    const buttonPrefix = expanded ? 'Hide' : 'View';
    const linkTarget = item.linkTarget ? item.linkTarget : '_self';

    return (
      <>
        {item.linkHref && item.hardCodedURL
          && (
          <a href={item.linkHref} rel="noopener noreferrer" target={linkTarget}>
              {item.linkText}
          </a>
          )
        }

        {item.linkHref && item.linkText === 'Print Shipping Label'
          && (
          <Link to={item.linkHref} target={linkTarget}>
              {item.linkText}
          </Link>
          )
        }

        {item.buttonText
          && (
          <button type="button" className="button button--text" onClick={item.clickAction ? item.clickAction.bind(this) : undefined}>
            {buttonPrefix}
            {' '}
            {item.buttonText}
          </button>
          )
        }
      </>
    );
  }

  render() {
    const { item } = this.props;
    const { expanded } = this.state;

    const className = expanded ? 'content-image--is-expanded' : '';

    return (
      <div className="card-group__item">
        <div className="card card--secondary card--action-right-at-768 card--flex-start how-to-return">
          <div className="card__content">
            <div className={`content-image ${className}`}>
              <div className="content-image__image">
                {renderIcon(item.icon)}
              </div>
              <div className="content-image__content">
                <div className="hgroup mb0">
                  <h3 className="body1">{item.title}</h3>
                  {/* eslint-disable-next-line react/no-danger */}
                  <p dangerouslySetInnerHTML={{ __html: item.content }} />
                </div>

                <div className="mobile">
                  {this.renderAction(item)}
                </div>

                {item.details && expanded && (
                  <ul>
                    {renderItemDetails(item.details)}
                  </ul>
                )}
              </div>
            </div>
          </div>
          <div className="card__action desktop">
            {this.renderAction(item)}
          </div>
        </div>
      </div>
    );
  }
}

export default HowToReturnItem;
